import { entryPoint } from "../util";
import { DemoIframe } from "./demo_iframe";

entryPoint(DemoIframe);
